import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Divider } from "samba-ui";

import StatusBar from "./StatusBar/index.js";
import {
  StyledHome,
  MainSection,
  RightNav,
  ButtonsContainer,
  Button
} from "./styles";
import CreateClientModal from "./CreateClientModal";
import CreateFeedModal from "./../Common/CreateFeedModal";
import {
  createClient,
  RECEIVE_CLIENT,
  CLIENT_CREATION_ERROR
} from "../../actions/client";
import { createFeed, RECEIVE_FEED } from "../../actions/feed";
import { CreateFeedIcon, CreateIcon } from "../../icons";
import { selectFeedsByStatus, selectAllFeeds } from "../../selectors";
import { ACTIVE, PROCESSING } from "../../constants";

import TabView from "../Common/TabView";

export class Home extends Component {
  state = {
    activeSquare: ACTIVE,
    showCreateClientModal: false,
    showCreateFeedModal: false,
    error: null
  };

  handleChangeSquare = this.handleChangeSquare.bind(this);
  handleClientSubmit = this.handleClientSubmit.bind(this);
  handleFeedSubmit = this.handleFeedSubmit.bind(this);

  handleChangeSquare(newSquare) {
    this.setState({ activeSquare: newSquare });
  }

  handleClientSubmit(client) {
    return this.props.createClient(client).then(action => {
      // Reset the error if it was successful
      // The modal is responsible for calling onDismiss when it should close
      if (action.type === RECEIVE_CLIENT) {
        this.setState({ error: null });
      }
      if (action.type === CLIENT_CREATION_ERROR) {
        this.setState({ error: action.error });
      }
      // Return action so any other function chaining a .then to
      // handleClientSubmit also has access to it
      return action;
    });
  }

  handleFeedSubmit(feed) {
    return this.props.createFeed(feed).then(action => {
      // Only set the activeSquare to processing if it was successful
      if (action.type === RECEIVE_FEED) {
        this.setState({ activeSquare: PROCESSING });
      }
      // Return action so any other function chaining a .then to
      // handleFeedSubmit also has access to it
      return action;
    });
  }

  render() {
    const {
      activeSquare,
      showCreateClientModal,
      showCreateFeedModal,
      error
    } = this.state;
    const { feeds } = this.props;
    return (
      <StyledHome>
        <MainSection>
          <StatusBar
            activeSquare={activeSquare}
            feeds={feeds}
            onChangeSquare={this.handleChangeSquare}
          />
          <TabView feeds={selectFeedsByStatus(feeds, activeSquare)} />
        </MainSection>
        <RightNav>
          <ButtonsContainer>
            <Button
              data-cy="create-client-btn"
              onClick={() => this.setState({ showCreateClientModal: true })}
            >
              <CreateIcon />
              Create a client
            </Button>
            <Button
              primary
              onClick={() => this.setState({ showCreateFeedModal: true })}
            >
              <CreateFeedIcon primary />
              Create a feed
            </Button>
          </ButtonsContainer>
          <Divider />
        </RightNav>
        <CreateClientModal
          show={showCreateClientModal}
          onDismiss={() =>
            this.setState({ showCreateClientModal: false, error: null })
          }
          onSubmit={this.handleClientSubmit}
          error={error}
          clearError={() => this.setState({ error: null })}
        />
        <CreateFeedModal
          show={showCreateFeedModal}
          onDismiss={() =>
            this.setState({ showCreateFeedModal: false, error: null })
          }
          onSubmit={this.handleFeedSubmit}
        />
      </StyledHome>
    );
  }
}

Home.propTypes = {
  feeds: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      client_id: PropTypes.number,
      created_at: PropTypes.string,
      delivery_schedule: PropTypes.string,
      kantar_filter_expression: PropTypes.shape({
        brand: PropTypes.arrayOf(PropTypes.string)
      }),
      name: PropTypes.string,
      pdp_infomediary: PropTypes.string,
      progress_ids: PropTypes.arrayOf(PropTypes.string),
      quality_metrics: PropTypes.shape({
        final_rowcount: PropTypes.number
      }),
      service_start: PropTypes.string,
      status: PropTypes.string,
      row_cnt: PropTypes.string,
      device_cnt: PropTypes.string,
      title_cnt: PropTypes.string,
      network_cnt: PropTypes.string,
      airing_cnt: PropTypes.string,
      brand: PropTypes.string,
      updated_at: PropTypes.string
    })
  ),
  createClient: PropTypes.func,
  createFeed: PropTypes.func
};

export default connect(
  store => ({
    feeds: selectAllFeeds(store)
  }),
  { createClient, createFeed }
)(Home);
